var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.actualClientAnamnesis.length > 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('ul', {
    staticClass: "list-group",
    attrs: {
      "data-testid": "client-anamnesis-list"
    }
  }, _vm._l((_vm.actualClientAnamnesis), function(a) {
    return _c('li', {
      staticClass: "list-group-item",
      attrs: {
        "data-testid": "client-anamnesis-entry",
        "data-anamnesis-type-id": a.anamnesis_type.id
      }
    }, [_c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(a.anamnesis_type.shortcode) + " - " + _vm._s(a.anamnesis_type.name))]), _c('br'), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(a.text)
      }
    })])
  }))]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ae475e0","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/ClientAnamnesis.vue
// module id = 632
// module chunks = 0